export const endPoints = {
  PAYMENT_FIELD: '/v1/payment/field'
};
